angular.module('wbDashboard').controller('AutoDepositMilestoneControllerAurea', ['$scope', '$timeout', 'Milestone', 'User', 'PlanService', 'Message', function ($scope, $timeout, Milestone, User, PlanService, Message) {

    $scope.pageData.page = "auto-deposit";

    Milestone.clearMS();
    $scope.milestone = Milestone.ms;
    $scope.MS = Milestone;

    $scope.$watch(function() { return User.getMilestones($scope.$stateParams.msId); }, function(milestone) {
        if (milestone) {
            Milestone.setMilestoneUpdateFromObject(milestone);
            $scope.milestone = Milestone.ms;
            Milestone.setBirthDate($scope.overview.user.birth_date);

            $scope.multi = $scope.milestone.accounts.length > 1;
            if ($scope.milestone.metadata.funding_strategy === 'calculated_waterfall') {
                $scope.multi = false;
            }

            Milestone.setDatesByMonthYear();
            if (!$scope.milestone.type_account && $scope.milestone.type !== 'wallet') {
                Milestone.getNewDefaultAutoDeposit();
            }

        } else {
            //placeholder data
            Milestone.ms = Milestone.loadingMilestone;
            $scope.milestone = Milestone.ms;
        }
    });

    $scope.$watch('$stateParams.page', function(page) {
        $scope.pageData.page = page;

        switch (page) {
            case 'auto-deposit':
                break;
            case 'auto-deposit-detail':
                var total = 0;
                angular.forEach($scope.milestone.accounts, function(account) {
                    total += account.auto_deposit;
                });
                total = Math.round(total*100)/100;

                if (total !== $scope.milestone.auto_deposit.amount) {
                    angular.forEach($scope.milestone.accounts, function(account) {
                        // account.auto_deposit = null;
                    });
                }
                break;
            case 'auto-deposit-confirm':
                $timeout(function() {
                    $scope.pageData.view.footer = true;
                });
                break;
        }
    });
    $scope.goToPage = function(page) {
        $scope.$state.go('.', {page: page});
    };


    // $scope.$watch('milestone', function(milestone) {
    // }, true);

    $scope.$watch('milestone.auto_deposit.amount', function(autoAmount) {
        if ($scope.milestone.type_account) return;
        if (["build_wealth", "wallet"].includes($scope.milestone.type)) return;

        if ((autoAmount || autoAmount === 0) && $scope.milestone) {
            $scope.pageData.updatingEst = true;
            Milestone.changedAutoDeposit().finally(function() {
                $scope.pageData.updatingEst = false;
            });

        }
    });
    $scope.$watch('milestone.accounts', function(accounts, oldAccounts) {
        Milestone.updateAutoDepositRemaining();
        Milestone.fixRemainingAutodeposits(accounts, oldAccounts);
    }, true);

    $scope.setPageDefaults = function() {
        Milestone.setSectionDefaults("auto-deposit");
    };

    $scope.saveAutoDeposit = function() {
        $scope.pageData.sending = true;

        var data = Milestone.prepareSubmitData($scope.milestone);
        Milestone.update(data).then(function() {

            $scope.$state.go("base.receipt", { receipt: {
                "action": "UPDATE_AUTO",
                "type": $scope.milestone.type,
                "milestone_name": $scope.milestone.name,
                "msId": $scope.milestone.id,
                "frequency": $scope.milestone.auto_deposit.frequency,
                "auto_amount": $scope.milestone.auto_deposit.amount,
                "old_auto_amount": $scope.milestone.extra.auto_deposit_original
            }});

            PlanService.user.retrieveAutos();
            User.retrieveOverview(true);
            User.retrieveMilestones($scope.$stateParams.msId, true);
            User.retrieveActivityPending(true);

        }).catch(function() {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

}]);
